/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var FieldInitMode;
(function (FieldInitMode) {
    FieldInitMode[FieldInitMode["FieldInitModeStatic"] = 0] = "FieldInitModeStatic";
    FieldInitMode[FieldInitMode["FieldInitModeFormula"] = 1] = "FieldInitModeFormula";
    FieldInitMode[FieldInitMode["FieldInitModeRelation"] = 2] = "FieldInitModeRelation";
    FieldInitMode[FieldInitMode["FieldInitModeSpecial1"] = 3] = "FieldInitModeSpecial1";
    FieldInitMode[FieldInitMode["FieldInitModeSpecial2"] = 4] = "FieldInitModeSpecial2";
    FieldInitMode[FieldInitMode["FieldInitModeSpecial3"] = 5] = "FieldInitModeSpecial3";
    FieldInitMode[FieldInitMode["FieldInitModeSpecial4"] = 6] = "FieldInitModeSpecial4";
    FieldInitMode[FieldInitMode["FieldInitModeSpecial5"] = 7] = "FieldInitModeSpecial5";
})(FieldInitMode || (FieldInitMode = {}));
